import type { TicketBadges } from '@/types/TicketBadges'
import type { TaskBadges } from '@/types/TaskBadges'
import type { LeaveCover } from '@/types/LeaveCover'
import { useColorTheme } from '@/Composables/useStockList'

import { OrganisationsData, Group, OrganisationState, StackedComponent, Shop } from '@/types/LayoutRules'
import { Colors } from "@/types/Color"
import { Navigation, grpNavigation, orgNavigation } from "@/types/Navigation"
import { Image } from "@/types/Image"
import { Notification } from '@/types/Notification'
import { Bookmark } from '@/types/Bookmark'

export const layoutStructure = {
    agents: {
        // currentOrganisations: '',
        data: [] as OrganisationsData[]
    },
    agentsState: {} as {[key: string]: OrganisationState},
    app: {
        name: "",  // For styling navigation depend on which App
        color: null as unknown | Colors,  // Styling layout color
        theme: useColorTheme[0] as string[],  // For styling app color
        navigation_theme: useColorTheme[0] as string[],  // Left navigation color, can be set per organisation
        organisation_colours: {} as { [key: string]: string },  // Left navigation color per organisation slug, sent on first load only
        url: null as string | null, // For url on logo top left
        environment: null as string | null, // 'local' | 'staging'
        last_deployment_at: null as string | null, // created_at of the latest app deployment
        last_deployment_hash: null as string | null, // hash of the latest commit
        last_deployment_version: null as string | null, // semantic version tag of the latest app deployment
        newVersionAvailable: false, // true after a post-deploy event when the user dismissed the refresh modal
    },
    currentModule: "",
    currentRoute: "grp.dashboard.show", // Define value to avoid route null at first load
    currentParams: {} as {[key: string]: string},
    currentQuery: {} as {[key: string]: string},
    digital_agency: null as {data: OrganisationsData[]} | null,
    group: null as Group | null,
    has_group_access: false,
    can_view_devops: false,
    help_portal_url: null as string | null,
    leftSidebar: {
        show: true,
    },
    messagingSidebar: {
        show: false,
        micro: false,
    },
    navigation: {
        grp: {} as grpNavigation,
        org: {} as { [key: string]: orgNavigation } | { [key: string]: Navigation } | Navigation
    },
    organisations: {
        data: [] as OrganisationsData[]
    },
    organisationsState: {} as {[key: string]: OrganisationState},
    shopState: {} as Shop,
    rightSidebar: {
        activeUsers: {
            users: [],
            count: 0,
            show: false
        },
        language: {
            show: false
        },
        message: {
            show: false
        },
        leaveCovers: {
            show: false,
            coveredLeaveIds: ""
        }
    },
    root_active: null as string | null,
    stackedComponents: [] as StackedComponent[],
    user: {} as {
        id: number,
        email: string,
        username: string,
        contact_name?: string,
        timezone: string | null,
        timezone_place: string | null,
        settings: {
            app_theme?: string[]
            hide_logo?: boolean
        }
    },
    notifications: [] as Notification[],
    avatar_thumbnail: null as Image | null,
    order_alerts: null as {
        shops: Record<number, string[]>
        sounds: Record<string, string>
        popup: { show: boolean }
    } | null,

    ticket_badges: null as TicketBadges | null,
    task_badges: null as TaskBadges | null,
    development_badges: null as { waiting: number, late: number, reminded?: boolean } | null,
    leave_covers: [] as LeaveCover[],
    dispatching_waiting_count: 0 as number,
    crm_waiting_count: 0 as number,
    crm_return_count: 0 as number,
    products_need_review_count: 0 as number,
    master_updated_count: 0 as number,
    faire_skipped_count: 0 as number,
    bookmarks: [] as Bookmark[],
}
